import { maxTokenCount } from '../hard-token-integration/max-token-count';

export class HardTokenAddController {

    /** @ngInject */
    constructor($state,HardTokenService,Alert) {
        this.HardTokenService = HardTokenService;
        this.Alert=Alert;
        this.$state=$state;
    }

    $onInit() {
        this.tokens = [{}];
        this.tokenCount = 1;
        this.editMode = 'table';
        this.saving = false;
        this.algorithm = 'SHA1';
        this.period = 30;
        this.type = null;
        this.otpType = null;
        this.maxTokenCount = maxTokenCount;
    }

    addTokens() {
        const tokens = this.tokens.map((token) => Object.assign({}, token, {
            type: this.type,
            otpType: this.otpType,
            algorithm: this.algorithm,
            period: this.otpType === 'TOTP' ? this.period : undefined,
        }));

        this.saving = true;

        this.HardTokenService.add(tokens)
            .then((response) => {
				this.$state.go('^', {}, {reload: '^'});
				this.Alert('success','company.hard-token-management.add-tokens.success');
            })
            .catch((rejection) => this.Alert('danger',rejection.message))
            .finally(() => this.saving = false);
    }

    countChanged() {
        if (this.tokenCount !== null && this.tokenCount < 1) {
            this.tokenCount = 1;
        } else if (this.tokenCount > this.maxTokenCount) {
            this.tokenCount = this.maxTokenCount;
        }
        this.tokens.length = this.tokenCount || 1;

        const newArray = (length) => Array.apply(null, {length});
        const emptyTokens = newArray(this.tokens.length).map(i => ({}));
        this.tokens = Object.assign(emptyTokens, this.tokens);
    }

    tokensChanged(tokens, valid) {
        this.tokens = tokens;
        this.tokenCount = tokens.length;
        this.valid = valid;
    }

    saveDisabled() {
        return !this.tokens.length || !this.valid || this.saving || this.editMode === 'csv';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/hard-token-add.controller.js